import React from "react";
import { useDispatch } from "react-redux";
import { ExpanderActions, expanderActions } from "components/form/Sections/reducers/expanders";
import { Dispatch } from "redux";
import { useContextualExpandableContainer } from "./Expandable";

const ExpandErrors: React.FC<{ containerKey?: string; getErrors: () => string[] }> = ({ getErrors, containerKey, children }) => {
    const dispatch = useDispatch<Dispatch<ExpanderActions>>();
    const container = useContextualExpandableContainer();

    React.useEffect(() => {
        const errors = getErrors();
        if (errors.length > 0) {
            dispatch(expanderActions.onExpandErrors({ containerKey: containerKey ?? container, expandersWithErrors: errors }));
        }
    }, [containerKey, getErrors, container, dispatch]);

    return <>{children}</>;
};

export default React.memo(ExpandErrors);
